const footLinks: { title: string; items: string[] }[] = [
  { title: '内容分区', items: ['今日热榜', '往期精选', '合集存档', '目录老帖'] },
  { title: '常用专区', items: ['绯闻瓜', '直播瓜', '综艺瓜', '商业瓜'] },
  { title: '关于本站', items: ['收录说明', '更新日志', '补录进度', '老帖复核'] },
];

export default function Footer() {
  return (
    <footer className="border-t border-amber-200/70 bg-gradient-to-b from-amber-100/70 to-amber-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.2fr_1fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5" aria-label="53吃瓜 回到顶部">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-red-500 to-orange-400 font-serif-sc text-base font-black text-white">
                瓜
              </span>
              <span className="font-serif-sc text-xl font-black text-stone-900">53吃瓜</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-stone-600">
              汇总往期精选、合集存档与目录老帖的整理向补漏站，按时间线复盘，帮你省去翻楼找帖的麻烦。
            </p>
            <div className="mt-5 flex gap-2">
              {['ri-wechat-2-line', 'ri-weibo-line', 'ri-qq-line', 'ri-rss-line'].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label={ic}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-stone-300/70 bg-white text-stone-600 transition-colors hover:border-red-400 hover:text-red-600"
                >
                  <i className={`${ic} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {footLinks.map((g) => (
            <nav key={g.title} aria-label={g.title}>
              <h4 className="text-sm font-bold text-stone-900">{g.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {g.items.map((it) => (
                  <li key={it}>
                    <a href="#top" className="text-sm text-stone-600 transition-colors hover:text-red-600">
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-stone-300/40 pt-6 sm:flex-row">
          <p className="text-xs text-stone-500">© 2026 53吃瓜 · 53吃瓜往期精选 / 合集存档 / 目录老帖复盘 · 仅作整理展示</p>
          <p className="flex items-center gap-4 text-xs text-stone-500">
            <a href="#top" className="transition-colors hover:text-red-600">收录标准</a>
            <a href="#top" className="transition-colors hover:text-red-600">内容来源说明</a>
            <a href="#top" className="transition-colors hover:text-red-600">联系整理者</a>
          </p>
        </div>
      </div>
    </footer>
  );
}